import React, { useState } from "react";
import "../../styles/db.css";
import { Row, Button } from "antd";
import { ControlOutlined } from "@ant-design/icons";
import PageHeader from "../../components/generic/PageHeader";

function RuleBuilder() {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (value) => {
    setIsOpen(value);
  };

  return (
    <div className="db-container">
      <PageHeader
        icon={<ControlOutlined />}
        title="Rule Builder"
        tooltip="Create and manage validation rules"
        actions={
          <Button className="db-add" onClick={() => openModal(true)}>
            New Rule
          </Button>
        }
      />
      <Row className="table-container">
        <div style={{ padding: "20px", textAlign: "center" }}>
          <p>Rule Builder functionality will be implemented here.</p>
        </div>
      </Row>
    </div>
  );
}

export default RuleBuilder;

